module.exports = __webpack_public_path__ + "img/HFIG-600-frequencydomain.2db9be2e.webp";